"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AppInfo = require("./AppInfo");
Object.keys(_AppInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppInfo[key];
    }
  });
});
